import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import OrderBalanceCollectionTable from './components/OrderBalanceCollectionTable';
import useOrderBalanceCollection from './hooks/useOrderBalanceCollection';
import OrderBalanceCollectionFilter from './components/OrderBalanceCollectionFilter';
import { useLanguage } from '../../../contexts/LanguageContext';

const OrderBalanceCollectionPage = () => {
  const { th } = useLanguage();

  const {
    toast,
    tableProps,
    filterFields,
    customFilterTypes,
    customFilterOptions,
    handleSearch,
    handleResetFilters,
    handleApplyFilters,
  } = useOrderBalanceCollection();

  const columnsRef = useRef(null);

  return (
    <div className="card">
      <Toast ref={toast} />

      <div className="flex justify-content-between align-items-center mb-4">
        <h1 className="m-0">{th('parts.orderBalanceCollection')}</h1>
      </div>

      <OrderBalanceCollectionFilter
        filterFields={filterFields}
        columns={columnsRef.current}
        customFilterTypes={customFilterTypes}
        customFilterOptions={customFilterOptions}
        handleSearch={handleSearch}
        handleApplyFilters={handleApplyFilters}
        handleResetFilters={handleResetFilters}
      />

      <OrderBalanceCollectionTable {...tableProps} />
    </div>
  );
};

export default OrderBalanceCollectionPage;
